import React, { Component } from 'react';
import Formatter from '../../utils/Formatter';
import FinancialTools from '../../utils/FinancialTools';
import { IconButton, Tooltip } from '@mui/material';
import Edit from '@mui/icons-material/Edit';
import Save from '@mui/icons-material/Save';
import Cancel from '@mui/icons-material/Cancel';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import CircularProgress from '@mui/material/CircularProgress';
import Validators from '../../utils/Validators';
import { connect } from 'react-redux';
import { showError, showMessage, confirmAction } from '../../actions/uiActions';
import AccountsApi from '../../api/accounts';
import Auth from '../../api/auth';
class Loans extends Component {
  state = {
    loan: null,
    busy: false
  };
  save = () => {
    if (
      !Validators.isCurrency(
        this.state.loan.loan_outstanding_principal_balance
      ) &&
      !this.state.loan.loan_outstanding_principal_balance
    )
      this.props.showError(
        'Please enter a valid outstanding principal balance.'
      );
    else if (
      !Validators.isCurrency(
        this.state.loan.loan_outstanding_interest_balance
      ) &&
      !this.state.loan.loan_outstanding_interest_balance
    )
      this.props.showError(
        'Please enter a valid outstanding interest balance.'
      );
    else if (
      !Validators.isCurrency(
        this.state.loan.loan_repayment_plan_scheduled_amount
      ) &&
      !this.state.loan.loan_repayment_plan_scheduled_amount
    )
      this.props.showError('Please enter a valid minimum monthly payment.');
    else if (this.state.loan.loan_status.length == 0)
      this.props.showError('Please enter the loan status.');
    else if (!this.state.loan.loan_repayment_plan_type)
      this.props.showError('Please enter the loan repayment plan.');
    else if (
      !Validators.isDateInput(this.state.loan.loan_repayment_plan_begin_date) &&
      !!Validators.isDate(this.state.loan.loan_repayment_plan_begin_date)
    )
      this.props.showError('Please enter a valid loan repayment start date.');
    else
      this.setState({ busy: true }, () => {
        let myStudentData = {
          ...this.props.myStudentData,

          student_loans: this.props.myStudentData.student_loans.map(loan => {
            loan.total_outstanding_principal = loan.loans.reduce(
              (total, subloan) => {
                if (subloan.loan_id == this.state.loan.loan_id)
                  return (
                    Formatter.moneyToNumber(
                      this.state.loan.loan_outstanding_principal_balance
                    ) + total
                  );
                else
                  return (
                    Formatter.moneyToNumber(
                      subloan.loan_outstanding_principal_balance
                    ) + total
                  );
              },
              0
            );
            loan.total_outstanding_interest = loan.loans.reduce(
              (total, subloan) => {
                if (subloan.loan_id == this.state.loan.loan_id)
                  return (
                    Formatter.moneyToNumber(
                      this.state.loan.loan_outstanding_interest_balance
                    ) + total
                  );
                else
                  return (
                    Formatter.moneyToNumber(
                      subloan.loan_outstanding_interest_balance
                    ) + total
                  );
              },
              0
            );
            loan.loans = loan.loans.map(childLoan => {
              if (childLoan.loan_id == this.state.loan.loan_id)
                return this.state.loan;
              return childLoan;
            });
            return loan;
          })
        };
        AccountsApi.updateMyStudentData(this.props.id, myStudentData)
          .then(
            success => {
              this.props.onLoanUpdated(myStudentData);
              this.props.showMessage('Loan updated successfully!');
              this.props.confirmAction(
                'The new loan information might impact the strategy found for this user. Would you like to run the analysis again with the new loan information?',
                () =>
                  AccountsApi.runAnalysis(this.props.id)
                    .then(
                      analysis => {
                        this.props.onAnalysisUpdated(analysis);
                        this.props.showMessage(
                          'The strategy has been updated to take into consideration the new loan information.'
                        );
                        this.setState({ busy: false, loan: null });
                      },
                      error => {
                        this.props.showError();
                        this.setState({ loan: null, busy: false });
                      }
                    )
                    .catch(error => {
                      this.props.showError();
                      this.setState({
                        edit_employment_info: false,
                        busy: false
                      });
                    }),
                'Update Analysis',
                'Run Analysis',
                "Don't Run it",
                () => this.setState({ loan: null, busy: false })
              );
            },
            error => {
              this.props.showError();
              this.setState({ busy: false });
            }
          )
          .catch(error => {
            this.props.showError();
            this.setState({ busy: false });
          });
      });
  };
  getServicer = loan => {
    let servicer = loan.loan_contact;
    return servicer
      ? {
          name: servicer.loan_contact_name,
          address: `${servicer.loan_contact_address1}${
            servicer.loan_contact_address2
              ? ` ${servicer.loan_contact_address2}`
              : ''
          }, ${servicer.loan_contact_city} ${servicer.loan_contact_state}`
        }
      : { name: 'Unknown', address: 'Unknown' };
  };
  render() {
    return (
      <div className="animated fadeIn">
        <div className="row">
          <div className="col-12">
            <Paper>
              <Table>
                <TableHead>
                  <TableRow>
                    <TableCell className="width10pct">
                      Outstanding Balances
                    </TableCell>
                    <TableCell className="width10pct">
                      Outstanding Interest
                    </TableCell>
                    <TableCell className="width10pct">
                      Min. Monthly Payment
                    </TableCell>

                    <TableCell className="width15pct paddingless">
                      Loan Status
                    </TableCell>
                    <TableCell className="width15pct paddingless">
                      Repayment Plan
                    </TableCell>
                    <TableCell className="width10pct">
                      Repayment Start
                    </TableCell>
                    <TableCell className="width5pct text-center">
                      PSLF
                    </TableCell>
                    <TableCell className="width15pct text-center">
                      Options
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {this.props.loan.loans.map((loan, index) => [
                    <TableRow className="clickable" key={index}>
                      <TableCell>
                        {(!this.state.loan ||
                          this.state.loan.loan_id != loan.loan_id) &&
                          `$${Formatter.money(
                            Formatter.moneyToNumber(
                              loan.loan_outstanding_principal_balance
                            )
                          )}`}
                        {this.state.loan &&
                          this.state.loan.loan_id == loan.loan_id && (
                            <input
                              disabled={this.state.busy}
                              className="form-control text-center"
                              type="number"
                              name="balance"
                              value={Formatter.moneyToNumber(
                                this.state.loan
                                  .loan_outstanding_principal_balance
                              )}
                              onChange={e => {
                                if (Validators.isCurrency(e.target.value))
                                  this.setState({
                                    loan: {
                                      ...this.state.loan,
                                      loan_outstanding_principal_balance:
                                        e.target.value
                                    }
                                  });
                              }}
                            />
                          )}
                      </TableCell>
                      <TableCell>
                        {(!this.state.loan ||
                          this.state.loan.loan_id != loan.loan_id) &&
                          `$${Formatter.money(
                            Formatter.moneyToNumber(
                              loan.loan_outstanding_interest_balance
                            )
                          )}`}
                        {this.state.loan &&
                          this.state.loan.loan_id == loan.loan_id && (
                            <input
                              disabled={this.state.busy}
                              className="form-control text-center"
                              type="number"
                              name="interest"
                              value={Formatter.moneyToNumber(
                                this.state.loan
                                  .loan_outstanding_interest_balance
                              )}
                              onChange={e => {
                                if (Validators.isCurrency(e.target.value))
                                  this.setState({
                                    loan: {
                                      ...this.state.loan,
                                      loan_outstanding_interest_balance:
                                        e.target.value
                                    }
                                  });
                              }}
                            />
                          )}
                      </TableCell>

                      <TableCell>
                        {(!this.state.loan ||
                          this.state.loan.loan_id != loan.loan_id) &&
                          `$${Formatter.money(
                            Formatter.moneyToNumber(
                              loan.loan_repayment_plan_scheduled_amount
                            )
                          )}`}
                        {this.state.loan &&
                          this.state.loan.loan_id == loan.loan_id && (
                            <input
                              disabled={this.state.busy}
                              className="form-control text-center"
                              type="number"
                              name="mmp"
                              value={Formatter.moneyToNumber(
                                this.state.loan
                                  .loan_repayment_plan_scheduled_amount
                              )}
                              onChange={e => {
                                if (Validators.isCurrency(e.target.value))
                                  this.setState({
                                    loan: {
                                      ...this.state.loan,
                                      loan_repayment_plan_scheduled_amount:
                                        e.target.value
                                    }
                                  });
                              }}
                            />
                          )}
                      </TableCell>

                      <TableCell className="paddingless">
                        {(!this.state.loan ||
                          this.state.loan.loan_id != loan.loan_id) &&
                          (loan.loan_status.length > 0
                            ? loan.loan_status[0].description
                            : 'Unknown')}
                        {this.state.loan &&
                          this.state.loan.loan_id == loan.loan_id && (
                            <select
                              disabled={this.state.busy}
                              className="form-control full-width"
                              name="status"
                              value={Formatter.codeStatus(
                                this.state.loan.loan_status[0].status
                              )}
                              onChange={e =>
                                this.setState({
                                  loan: {
                                    ...this.state.loan,
                                    loan_status:
                                      this.state.loan.loan_status.length > 1
                                        ? [
                                            {
                                              status: Formatter.statusCode(
                                                e.target.value
                                              ),
                                              description: Formatter.statusText(
                                                e.target.value
                                              ),
                                              date: Formatter.toStandardDate(
                                                this.state.loan
                                                  .loan_repayment_plan_begin_date
                                              )
                                            },
                                            ...this.state.loan.loan_status.slice(
                                              1
                                            )
                                          ]
                                        : [
                                            {
                                              status: Formatter.statusCode(
                                                e.target.value
                                              ),
                                              description: Formatter.statusText(
                                                e.target.value
                                              ),
                                              date: Formatter.toStandardDate(
                                                this.state.loan
                                                  .loan_repayment_plan_begin_date
                                              )
                                            }
                                          ]
                                  }
                                })
                              }
                            >
                              {[0, 1, 2, 3, 4, 5, 6, 7, 8].map(status => (
                                <option key={status} value={status}>
                                  {Formatter.statusText(status)}
                                </option>
                              ))}
                            </select>
                          )}
                      </TableCell>
                      <TableCell className="paddingless">
                        {(!this.state.loan ||
                          this.state.loan.loan_id != loan.loan_id) &&
                          loan.loan_repayment_plan_type}
                        {this.state.loan &&
                          this.state.loan.loan_id == loan.loan_id && (
                            <select
                              disabled={this.state.busy}
                              value={Formatter.repaymentPlanCode(
                                this.state.loan.loan_repayment_plan_type
                              )}
                              onChange={e =>
                                this.setState({
                                  loan: {
                                    ...this.state.loan,
                                    loan_repayment_plan_type: Formatter.repaymentPlanText(
                                      e.target.value
                                    )
                                  }
                                })
                              }
                              className="form-control"
                            >
                              {[0, 1, 2, 3, 4, 5, 6, 7, 8, 9].map(plan => (
                                <option key={plan} value={plan}>
                                  {Formatter.repaymentPlanText(plan)}
                                </option>
                              ))}
                            </select>
                          )}
                      </TableCell>
                      <TableCell>
                        {(!this.state.loan ||
                          this.state.loan.loan_id != loan.loan_id) &&
                          loan.loan_repayment_plan_begin_date}
                        {this.state.loan &&
                          this.state.loan.loan_id == loan.loan_id && (
                            <input
                              disabled={this.state.busy}
                              className="form-control text-center"
                              type="date"
                              name="date"
                              value={Formatter.toInputDate(
                                this.state.loan.loan_repayment_plan_begin_date
                              )}
                              onChange={e => {
                                if (Validators.isDateInput(e.target.value))
                                  this.setState({
                                    loan: {
                                      ...this.state.loan,
                                      loan_repayment_plan_begin_date: Formatter.toStandardDate(
                                        e.target.value
                                      )
                                    }
                                  });
                              }}
                            />
                          )}
                      </TableCell>
                      <TableCell className="text-center">
                        {loan.loan_pslf_matched_monts || 0}
                      </TableCell>
                      <TableCell className="text-center">
                        {Auth.account.role != 'sales' &&
                          (!this.state.loan ||
                            this.state.loan.loan_id != loan.loan_id) && (
                            <Tooltip title="Edit Loan">
                              <IconButton
                                onClick={() => this.setState({ loan })}
                              >
                                <Edit />
                              </IconButton>
                            </Tooltip>
                          )}
                        {this.state.busy &&
                          this.state.loan &&
                          this.state.loan.loan_id == loan.loan_id && (
                            <CircularProgress size={20} />
                          )}
                        {!this.state.busy &&
                          this.state.loan &&
                          this.state.loan.loan_id == loan.loan_id && (
                            <div>
                              <Tooltip title="Save Changes">
                                <IconButton onClick={this.save}>
                                  <Save />
                                </IconButton>
                              </Tooltip>
                              <Tooltip title="Cancel Changes">
                                <IconButton
                                  onClick={() => this.setState({ loan: null })}
                                >
                                  <Cancel />
                                </IconButton>
                              </Tooltip>
                            </div>
                          )}
                      </TableCell>
                    </TableRow>,
                    <TableRow>
                      <TableCell className="servicer-line" colSpan={8}>
                        <span className="margin-rigth20px">
                          <b>Servicer name:</b> {this.getServicer(loan).name}
                        </span>{' '}
                        <b>Servicer Address:</b>{' '}
                        {this.getServicer(loan).address}
                      </TableCell>
                    </TableRow>
                  ])}
                </TableBody>
              </Table>
            </Paper>
          </div>
        </div>
      </div>
    );
  }
}
const mapStateToProps = state => {
  return state;
};
export default connect(mapStateToProps, {
  showError,
  showMessage,
  confirmAction
})(Loans);
